import React from "react";
import { useNavigate } from "react-router-dom";
import "./Card.css";

function Card({ title, iconSrc, theme ,type}) {
  const navigate = useNavigate();

  const handleClick = () => {
    // navigate to product list page by category name
    navigate(`/products/${type.toLowerCase()}`);
  };

  return (
    <div className={`custom-card theme-${theme}`} onClick={handleClick}>
      <img src={iconSrc} alt={title} className="custom-card-icon" />
      <div className="custom-card-title">{title}</div>
    </div>
  );
}

export default Card;

